import { useCustomerStore } from '@stores/me/customer'

import { defineNuxtRouteMiddleware, useRouter } from '#app'

export default defineNuxtRouteMiddleware( async (to) => {
  const customerStore = useCustomerStore()

  if (customerStore.isTypeDemo) {
    const redirectUrl = to.path.replace('/pricing', '/pad')
    const router = useRouter()

    await router.push(redirectUrl)
  }
})
